<div class="td-login-container">
  <div class="td-login-content" [class.td-login-regClosed]="!siteRegistrationOpen || tdSupportLogin || appCycleItinerary || noInternalUser">
    <img src="/index.cfm?FuseAction=Abroad.LoginLogo" alt="Institution Logo" class="td-login-logo" *ngIf="loginLogo !== ''">
    <div class="td-loading-container" *ngIf="isLoading">
      <mat-spinner class="td-loading"></mat-spinner>
    </div>
    <div class="td-login-main" *ngIf="tdLogin && !isLoading">
      <ng-container *ngIf="!(passwordReset || appCycleItinerary || tdPasswordReset) && !tdSupportLogin">
        <h2>User Login</h2>
        <div class="td-login-assist-text">
          <p [innerHTML]="i18nFields.userLoginHelpText | safe: 'html'"></p>
        </div>
        <div class="td-login-buttons">
          <div class="td-login-button td-sso-login-button" *ngIf="remoteLoginURL !== ''">
            <a href="{{remoteLoginURL}}" mat-flat-button class="td-login-btn" [style.background-color]="primaryColor">{{ i18nFields.ssoLoginButtonText }}</a>
          </div>
          <div class="td-login-button td-local-login-button" *ngIf="(!loginType || tdSupportLogin) && remoteLoginURL !== ''">
            <button mat-flat-button class="td-login-btn" [style.background-color]="primaryColor" (click)="useLocalTDSLoginForm()">{{ i18nFields.tdsLoginButtonText }}</button>
          </div>
        </div>        
      </ng-container>
      <div class="td-login-main" *ngIf="passwordReset">
        <h2>Password Reset</h2>
        <div class="td-login-assist-text">
          <p [innerHTML]="i18nFields.passwordResetHelpText | safe: 'html'"></p>
        </div>
      </div>
      <div *ngIf="useTDSLogin || tdSupportLogin">
        <app-login-form [primaryColor]="primaryColor" 
                        [loginRegistrationOptions]="loginRegistrationOptions" 
                        [rcValue]="rcValue"
                        [programId]="programId"
                        [i18nFields]="i18nFields"
                        (formMode)="userFormChange($event)"
                        (activeAppCycleResults)="appCycleItineraryReq($event)"
                        (redirectURL)="setRedirectURL($event)"
                        (applicantUserId)="setUserId($event)"
                        (tempPW)="setTempPW($event)"
                        (tdPasswordResetForm)="passwordResetForm($event)"></app-login-form>
      </div>     
    </div>
    <div *ngIf="appCycleItinerary">
      <ng-container *ngIf="!appCycleLoading">
        <ng-container *ngIf="userCanApply">
          <app-application-cycle [primaryColor]="primaryColor" 
                                 [redirectURL]="redirectURL" 
                                 [userId]="userId"
                                 [activeAppCycleResults]="activeAppCycleResults"
                                 [programId]="pId"
                                 [isISSS]="isISSS"></app-application-cycle>
        </ng-container>
        <ng-container *ngIf="!userCanApply">
          <p class="td-user-ineligible" *ngIf="ineligibleAppType !== ''">
            {{ ineligibleAppType }}
          </p>
          <p class="td-user-app-exists" *ngIf="appExists !== ''">
            {{ appExists }}
          </p>
          <div class="td-cant-apply">
            <a href="/index.cfm?FuseAction=Programs.Home" mat-flat-button class="td-programs-redirect-btn" [style.background-color]="primaryColor">Return to Program Search</a>
            <a *ngIf="appExists !== ''" href="/index.cfm?FuseAction=Portal.Home" mat-flat-button class="td-programs-redirect-btn" [style.background-color]="primaryColor">Go to Applicant Home</a>
          </div>
        </ng-container>
      </ng-container>
      
    </div>
    <div *ngIf="tdRegistration">
      <h2>User Registration</h2>
      <div class="td-login-assist-text">
        <p [innerHTML]="i18nFields.userRegistrationHelpText | safe: 'html'"></p>
      </div>
      <app-registration [primaryColor]="primaryColor" 
                        [loginRegistrationOptions]="loginRegistrationOptions" 
                        [programId]="programId"
                        [i18nFields]="i18nFields"                    
                        [rcValue]="rcValue"
                        [institutionName]="institutionName"
                        (formMode)="userFormChange($event)"
                        (activeAppCycleResults)="appCycleItineraryReq($event)"
                        (redirectURL)="setRedirectURL($event)"
                        (applicantUserId)="setUserId($event)"></app-registration>
    </div>
    <div *ngIf="tdPasswordReset">
      <app-password-reset [primaryColor]="primaryColor" 
                          [loginRegistrationOptions]="loginRegistrationOptions" 
                          [redirectURL]="redirectURL" 
                          [userId]="userId"
                          [programId]="programId"
                          [i18nFields]="i18nFields"                    
                          [rcValue]="rcValue"
                          [tempPW]="tempPW"
                          (formMode)="userFormChange($event)"
                          (activeAppCycleResults)="appCycleItineraryReq($event)"
                          (redirectURL)="setRedirectURL($event)"
                          (applicantUserId)="setUserId($event)"></app-password-reset>
    </div>
  </div>
  <div class="td-login-bottom-section" *ngIf="(siteRegistrationOpen || (!siteRegistrationOpen && (programId > 0 || rcValue > 0))) && !tdSupportLogin && !isLoading && !appCycleItinerary && !noInternalUser || (!SCLEnabled && !externalStudents && internalStudents)">
    <div *ngIf="tdLogin">
      New User? <button mat-button (click)="tdLoginRegistrationFormLoad()" aria-label="New User Create Account">Create Account</button>
    </div>
    <div *ngIf="!tdLogin">
      Already have an account? <button mat-button (click)="tdLoginRegistrationFormLoad()" aria-label="Login Now">Login Now</button>
    </div>
  </div>

</div>